import { useQuery } from "react-query";
import { fetchTicketPriorites } from "../services/api/tickets";

export default function useTicketPriorities() {
	return useQuery({
		queryFn: fetchTicketPriorites,
		queryKey: ["TicketPriorites"],
	});
}
